// Helper to get the correct API base URL based on environment
export const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000';
  }
  // In production, API calls should be relative (handled by Nginx proxy)
  // Don't add /api prefix here as it's handled by the web server
  return '';
};

export default getApiUrl;
